/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for subscription upgrade
 * @export
 * @interface SubscriptionUpgradeResponse
 */
export interface SubscriptionUpgradeResponse {
    /**
     * Whether the upgrade was successful
     * @type {boolean}
     * @memberof SubscriptionUpgradeResponse
     */
    success: boolean;
    /**
     * Human-readable result message
     * @type {string}
     * @memberof SubscriptionUpgradeResponse
     */
    message: string;
    /**
     * The Stripe subscription ID that was upgraded
     * @type {string}
     * @memberof SubscriptionUpgradeResponse
     */
    subscriptionId: string;
}

/**
 * Check if a given object implements the SubscriptionUpgradeResponse interface.
 */
export function instanceOfSubscriptionUpgradeResponse(value: object): value is SubscriptionUpgradeResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('subscriptionId' in value) || value['subscriptionId'] === undefined) return false;
    return true;
}

export function SubscriptionUpgradeResponseFromJSON(json: any): SubscriptionUpgradeResponse {
    return SubscriptionUpgradeResponseFromJSONTyped(json, false);
}

export function SubscriptionUpgradeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionUpgradeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
        'subscriptionId': json['subscriptionId'],
    };
}

export function SubscriptionUpgradeResponseToJSON(json: any): SubscriptionUpgradeResponse {
    return SubscriptionUpgradeResponseToJSONTyped(json, false);
}

export function SubscriptionUpgradeResponseToJSONTyped(value?: SubscriptionUpgradeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'subscriptionId': value['subscriptionId'],
    };
}

